export default [
    {
        path: '/customer-leads',
        name: 'customer-leads',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/CustomerLeads/CustomerLeads.vue')
    }
]
